import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref, toRef, nextTick, watch } from 'vue';
import ChatView from "@/views/message/Chat.vue";
import Message from "@/views/message/Message.vue";
import { PlayerModel } from '@/model/playerModel';
import EventBus from '@/uitls/EventBus';
import IMUtils from "@/network/socket/imUtils";
import { getImUser } from "@/network/db/dbServe";
import { imUserModel } from "@/model/chatModel";

import { useWindowSize } from '@vant/use';

export default /*#__PURE__*/_defineComponent({
  name: 'PlayerPrivateChat',
  props: {
    roomdata: { type: null, required: true },
    autoMsg: { type: String, required: false }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    roomdata: PlayerModel,
    autoMsg?: string,
}

_useCssVars(_ctx => ({
  "e1fa93b4-screenHeight": (screenHeight.value)
}))

const { width, height } = useWindowSize();
const screenHeight = ref('');



const roomdata = toRef(props, 'roomdata');

const isSixin = ref(false);
const zb_chatkey = ref('');
const zb_autoMsg = ref('');

const parseAutoMsgConfig = (raw) => {
    if (typeof raw === 'string') {
        try {
            raw = JSON.parse(raw);
        } catch (e) {
            return [];
        }
    }
    if (!Array.isArray(raw)) {
        return [];
    }
    return raw.filter((item) => item && item.content !== undefined && item.content !== null);
};

const hasLiveRoomAutoMsgConfig = computed(() => {
    const setData = roomdata.value && roomdata.value.set_data ? roomdata.value.set_data : {};
    const assistanceMessages = parseAutoMsgConfig(setData['automatically_send_data_assistance']);
    if (assistanceMessages.length > 0) {
        return true;
    }
    return parseAutoMsgConfig(setData['automatically_send_data']).length > 0;
});
const chatAutoMsg = computed(() => hasLiveRoomAutoMsgConfig.value ? (props.autoMsg || '') : zb_autoMsg.value);

// 重置组件状态
const resetState = () => {
    isSixin.value = false;
    zb_chatkey.value = '';
    zb_autoMsg.value = '';
};

onMounted(async () => {
    resetState();

    if (roomdata.value.free_id) {
        zb_chatkey.value = IMUtils.createChatKey(roomdata.value.free_id).toString();
        await checkAutoMsgToZB();
        nextTick(() => {
            isSixin.value = true;
        });
    }
    nextTick(() => {
        screenHeight.value = `${height.value}px`;
    });
});

watch(() => roomdata.value, async (newVal, oldVal) => {
    if (newVal && newVal.free_id) {
        resetState();
        zb_chatkey.value = IMUtils.createChatKey(newVal.free_id).toString();
        await checkAutoMsgToZB();
        nextTick(() => {
            isSixin.value = true;
        });
    }
}, { immediate: false });

onUnmounted(() => {
    // 清理状态
    resetState();
});

const priviteGoback = () => {
    isSixin.value = false;
    zb_chatkey.value = '';
};

const tochat = (chatKey) => {
    zb_chatkey.value = chatKey;
    nextTick(() => {
        isSixin.value = true;
    });
};

const checkAutoMsgToZB = async () => {
    let data = roomdata.value;
    console.log('automatically_send', data.set_data['automatically_send']);
    // imChatModel
    let autosend = data.set_data['automatically_send_data'];
    if (!autosend) {
        return;
    }
    let userModel: imUserModel = await getImUser(data.free_id);

    let list = [];
    for (let i = 0; i < autosend.length; i++) {
        const item = autosend[i];
        let automsgtype = item['type'];
        let content = item['content'];
        let msgtype = automsgtype || 1;

        if (msgtype == 10013) {
            // 复制主播ID
            content = JSON.parse(content);
        }

        if (autosend && autosend != '') {
            list.push({
                id: i + 1,
                chatkey: zb_chatkey.value + '',
                chatmsgno: i - autosend.length,
                uid: data.free_id,
                content: content,
                headurl: userModel && userModel.headurl ? userModel.headurl : data.portrait,
                nickname: userModel && userModel.nickname ? userModel.nickname : data.nickname,
                phonenum: "",
                time: Date.now() - (autosend.length - i) * 10000,
                msgtype: msgtype,
                clientkey: 'h5',
                read: true,
                send: true,
                upLoadProgress: 100,
            });
        }
    }

    // list = list.reverse();

    zb_autoMsg.value = JSON.stringify(list);
}

EventBus.autoOn('changeToPrivate', async (source: number) => {
    console.log('收到 changeToPrivate 事件，来源:', source);
    if (roomdata.value.free_id) {
        zb_chatkey.value = IMUtils.createChatKey(roomdata.value.free_id).toString();
        await checkAutoMsgToZB();

        nextTick(() => {
            if (source === 1) {
                isSixin.value = false;
            } else {
                isSixin.value = true;
            }
        });
    }
});

// 监听重置事件
EventBus.autoOn('resetPrivateChat', () => {
    console.log('收到重置私聊事件');
    resetState();
});


const __returned__ = { width, height, screenHeight, props, roomdata, isSixin, zb_chatkey, zb_autoMsg, parseAutoMsgConfig, hasLiveRoomAutoMsgConfig, chatAutoMsg, resetState, priviteGoback, tochat, checkAutoMsgToZB, ChatView, Message }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})